@use "../../../sass/global/global" as *;

ux-iws-nb-all-in-one-detail-group {
    --background-color: #{$color-blue-headline};
    --heading-color: #{$color-white};
    --text-color: #{$color-white};

    --ux-button-text-color: #{$color-white};
    --ux-button-bg-color: transparent;
    --ux-button-border-color: #{$color-white};
    --ux-button-hover-border-color: #{$color-white};

    --ux-checkbox-border-color: #{$color-white};
    --ux-checkbox-hover-border-color: #{$color-green};
    --ux-checkbox-text-color: #{$color-white};
    --ux-input-active-bg: transparent;
    --ux-input-active-text-color: #{$color-white};
    --ux-input-active-border-color: #{$color-white};
    --ux-input-hover-text-color: #{$color-green};
    --ux-input-hover-border-color: #{$color-green};
    --ux-input-focus-border-color: #{$color-green};
    --ux-input-focus-text-color: #{$color-white};
    --ux-radio-dot-color: #{$color-green};
}

ux-iws-nb-all-in-one-detail-group {
    display: block;
    box-sizing: border-box;
    @include font(light);
    background-color: var(--background-color);
    color: var(--text-color);
    width: 100%;
    height: 0;
    overflow: hidden;
    transition: height 0.3s ease-out;

    .ux-radio-button__input:checked {
        ~ .ux-radio-button__label::before {
            --ux-checkbox-border-color: #{$color-green};
            background-color: $color-white;
        }

        ~ .ux-radio-button__label::after {
            background-color: $color-green;
        }
    }
}

@keyframes nb-all-in-one-slide-in {
    from {
        transform: translateY(-40px);
        opacity: 0;
    }

    to {
        transform: none;
        opacity: 1;
    }
}

@keyframes nb-all-in-one-slide-out {
    from {
        transform: none;
        opacity: 1;
    }

    to {
        transform: translateY(-40px);
        opacity: 0;
    }
}

ux-iws-nb-all-in-one-detail-group[active]:not([active="false"]) {
    height: auto;

    .ux-iws-nb-all-in-one-detail-group__inner {
        animation: nb-all-in-one-slide-in 0.3s ease-out;
    }
}

.ux-iws-nb-all-in-one-detail-group {
    &__inner {
        display: block;
        animation: nb-all-in-one-slide-out 0.3s ease-out;

        @media (min-width: 1440px) {
            display: flex;
            flex-flow: row nowrap;
            align-items: stretch;
            justify-content: stretch;
        }
    }

    &__items {
        flex: 1 1 auto;
    }

    &__navigation {
        display: block;
        padding: 30px;

        @media (min-width: 1440px) {
            flex-shrink: 0;
            width: 300px;
        }
    }

    &__radios {
        display: flex;
        flex-flow: row wrap;
        align-items: flex-start;
        justify-content: flex-start;
        row-gap: 10px;

        @media (min-width: 1440px) {
            flex-direction: column;
            border-left: 1px solid #fff;
            padding-left: 15px;
        }
    }
}
